import SeasonFilter from "./SeasonFilter";
import SeriesFilter from "./SeriesFilter";
import SportFilter from "./SportFilter";

interface FantasyFiltersBarProps {
	className?: string;
}

const FantasyFiltersBar = ({ className = "pb-3 pt-3" }: FantasyFiltersBarProps) => {
	return (
		<div className={`fantasy-filters-bar ${className}`}>
			<div className="fantasy-filters-bar__section fantasy-filters-bar__section--sport">
				<SportFilter />
			</div>
			<div className="fantasy-filters-bar__divider" />
			<div className="fantasy-filters-bar__section fantasy-filters-bar__section--season">
				<SeasonFilter />
			</div>
			<div className="fantasy-filters-bar__section fantasy-filters-bar__section--series">
				<SeriesFilter />
			</div>
		</div>
	);
};

export default FantasyFiltersBar;
